export default __webpack_public_path__ + "static/media/cargo-home-banner-2.63e6d788.jpeg";